export default {
  name: {
    presence: { allowEmpty: false }
  },
  pricingPlan: {
    presence: { allowEmpty: false }
  }
};
